import React, { useState, useContext } from 'react';
import { PeopleContext } from '../context/PeopleContex';
import Input from './Input';

const initialState = {
  fullName: '',
  dateOfBirth: '',
  tags: '',
  note: '',
};

function AddForm() {
  const { addPerson } = useContext(PeopleContext);
  const [formValue, setFormValue] = useState(initialState);

  function handlerFormValue(event) {
    event.preventDefault();
    const key = event.target.name;
    const value = event.target.value;
    setFormValue({ ...formValue, [key]: value });
  }

  function handlerSubmit(event) {
    event.preventDefault();
    const newPerson = {
      ...formValue,
      tags: formValue.tags.split(' '),
    };
    addPerson(newPerson);
    setFormValue(initialState);
  }
  return (
    <section>
      <form onSubmit={(event) => handlerSubmit(event)}>
        <h2>Add person to database:</h2>
        <Input
          type="text"
          name="fullName"
          value={formValue.fullName}
          onChange={(event) => handlerFormValue(event)}
          label="Full name:"
        />
        <Input
          type="date"
          name="dateOfBirth"
          value={formValue.dateOfBirth}
          onChange={(event) => handlerFormValue(event)}
          label="Birth date:"
        />
        <Input
          type="text"
          name="tags"
          value={formValue.tags}
          onChange={(event) => handlerFormValue(event)}
          label="Tags:"
        />
        <Input
          type="text"
          name="note"
          value={formValue.note}
          onChange={(event) => handlerFormValue(event)}
          label="Note:"
        />
        <Input
          type="submit"
          name="submit"
          value="Add person!"
          className="sumbitInput"
        />
      </form>
    </section>
  );
}

export default AddForm;
